import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from '../services/auth';
import { jwtDecode } from 'jwt-decode'; // Need to add this dependency

interface DecodedToken {
  sub: string;
  is_admin: boolean;
  exp: number;
}

const AdminRoute: React.FC = () => {
  const user = getCurrentUser();

  if (!user) {
    return <Navigate to="/login" />;
  }

  try {
    const decodedToken: DecodedToken = jwtDecode(user.access_token);
    if (!decodedToken.is_admin) {
      return <Navigate to="/" />;
    }
  } catch (error) {
    console.error("Invalid token:", error);
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default AdminRoute;
